import Observer from "../../../../observer/observer.js";

export default class Insert extends Observer {
  constructor(data) {
    super();

    this._data = data;
  }

  getData() {
    return this._data;
  }
}
